import { render, staticRenderFns } from "./LeaderboardHome.vue?vue&type=template&id=1d0fcbd3&scoped=true&"
import script from "./LeaderboardHome.vue?vue&type=script&lang=js&"
export * from "./LeaderboardHome.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardHome.vue?vue&type=style&index=0&id=1d0fcbd3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0fcbd3",
  null
  
)

export default component.exports